import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const RadioButton = ({
	title,
  isChecked,
  onClick,
	style,
}) => (
  <div className="button-radio" onClick={onClick} style={style}>
    <div className={`button-radio__checkbox ${isChecked && 'button-radio__checkbox__checked'}`} />
    <span className="button-radio__text">{title}</span>
  </div>
);

RadioButton.propTypes = {
  title: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
	style: PropTypes.object,
};

RadioButton.defaultProps = {
	style: {},
};

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/ui/Buttons/RadioButton/index.js